module.exports = __webpack_public_path__ + "img/mp.006ddf4a.png";